function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'chocobruin': 'rgb(101, 67, 33)','zwart': 'rgb(0, 0, 0)','grijs': 'rgb(161, 161, 161)','creme': 'rgb(245, 240, 218)','beige': 'rgb(216, 195, 165)','donkerbruin': 'rgb(75, 46, 32)','donkergrijs': 'rgb(74, 74, 74)','blauw': 'rgb(31, 78, 140)','olijfgroen': 'rgb(107, 142, 35)','kakigroen': 'rgb(120, 134, 107)','khakigroen': 'rgb(122, 132, 80)','taupe': 'rgb(142, 124, 106)','burgundy': 'rgb(122, 15, 28)','botergeel': 'rgb(247, 225, 113)','navyblauw': 'rgb(10, 29, 69)','mintgroen': 'rgb(152, 255, 152)','oceaangroen': 'rgb(26, 127, 122)','rood': 'rgb(179, 32, 38)','donkergroen': 'rgb(14, 59, 46)','wit': 'rgb(255, 255, 255)','petrolblauw': 'rgb(5, 106, 127)','roze-wit': 'rgb(244, 167, 185)','blauw-wit': 'rgb(167, 211, 243)','roze': 'rgb(210, 106, 138)','paars': 'rgb(123, 63, 160)','limoen': 'rgb(166, 214, 8)','donkerrood': 'rgb(122, 27, 38)','bruin': 'rgb(106, 70, 50)','ecru': 'rgb(232, 226, 210)','groen': 'rgb(122, 121, 83)',};

    this.images = {};

    this.triggers = ['kleur','color',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
